import { render, staticRenderFns } from "./MixinDelete.vue?vue&type=template&id=2b2963f9&lang=html&"
import script from "./MixinDelete.vue?vue&type=script&lang=js&"
export * from "./MixinDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports